import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowsShow: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrows-show, expand, maximize"><path d="M9 5.75L12 2.75L15 5.75" stroke="currentColor" strokeWidth="1.5"/><path d="M15 18.25L12 21.25L9 18.25" stroke="currentColor" strokeWidth="1.5"/><path d="M12 10V3.5" stroke="currentColor" strokeWidth="1.5"/><path d="M12 20.5V14" stroke="currentColor" strokeWidth="1.5"/><path d="M8 8.75H2.75V15.25H8" stroke="currentColor" strokeWidth="1.5"/><path d="M16 8.75H21.25V15.25H16" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconArrowsShow;
